import { render, staticRenderFns } from "./modal-window.vue?vue&type=template&id=52a2bed5&scoped=true"
import script from "./modal-window.vue?vue&type=script&lang=ts"
export * from "./modal-window.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a2bed5",
  null
  
)

export default component.exports